// Marca `imagenes_generadas.descargada = true` para las creaciones que la persona ACABA de
// bajar. Es el único indicador de "se llevó la foto" que tiene la base, y hasta el
// 2026-09-17 lo escribían sólo tres pantallas viejas (el inline, el historial y el video
// inline): la columna de resultados de la V2, Flujos, el ZIP de un lanzamiento y las
// piezas de un post bajaban sin marcar nada, así que la tasa de descarga por modo medía
// en qué pantalla se abrió el resultado y no si la foto sirvió
// (ADR-2026-09-17-la-descarga-de-v2-y-flujos-no-marca-descargada).
//
// Dos reglas:
//   · Se llama DESPUÉS de que la descarga salió de verdad. Nunca al abrir el selector de
//     formato (cancelar ahí no es una descarga) ni cuando el fetch falló.
//   · Nunca bloquea ni hace fallar la descarga: la persona ya tiene su archivo; si la marca
//     no se pudo escribir, va un warning a la consola y nada más. Por eso se llama con
//     `void` y no se espera.
//
// El `id_company` es opcional y sólo agrega un filtro extra cuando el host lo tiene a mano
// (la RLS ya acota la fila a la empresa del usuario); Flujos no lo tiene en cada nodo.

import { supabase } from '../lib/supabase';
import { chunkArray, SUPABASE_IN_CHUNK_SIZE } from './supabaseChunkedIn';

export async function marcarDescargadas(
  ids: ReadonlyArray<string | null | undefined>,
  companyId?: string | null,
): Promise<void> {
  const unicos = [...new Set(ids.filter((id): id is string => typeof id === 'string' && id.length > 0))];
  if (unicos.length === 0) return;
  // Por tandas: el `.in()` viaja por URL y con muchos ids da HTTP 400 (mismo motivo que
  // `fetchInChunks`). Un zip de una corrida grande de Flujos puede traer decenas.
  for (const tanda of chunkArray(unicos, SUPABASE_IN_CHUNK_SIZE)) {
    try {
      let q = supabase.from('imagenes_generadas').update({ descargada: true }).in('id', tanda);
      if (companyId) q = q.eq('id_company', companyId);
      const { error } = await q;
      if (error) console.warn('[descargas] no se pudo marcar como descargada', error);
    } catch (e) {
      console.warn('[descargas] no se pudo marcar como descargada', e);
    }
  }
}
